/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { PaymentBookingItem } from "../../types/Payments";
import moment from "moment";

type Props = {
  rows: PaymentBookingItem[];
  count?: number;
  page?: number;
  onPageChange?: (e: any, newPage: number) => void;
};

const PaymentsList = ({ rows, count, page = 1, onPageChange }: Props) => {
  const navigate = useNavigate();

  const columns: GridColDef<PaymentBookingItem>[] = [
    {
      flex: 1,
      minWidth: 220,
      field: "userDetails",
      headerName: "Customer Detail",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const fullName = `${row.userDetails.firstName} ${row.userDetails.lastName}`.trim();
        return (
          <div
            className="user_block click_action"
            onClick={() => navigate('/manage-customers/detail')}
          >
            <figure>
              <img src={row.userDetails.image || "/static/images/user_placeholder.png"} alt="" />
            </figure>
            <p><b>{fullName}</b> <span>{row.userDetails.email}</span></p>
          </div>
        );
      },
    },
    {
      minWidth: 150,
      field: "totalAmount",
      headerName: "Total Amount",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: ({ row }) => <p><strong>${row.totalAmount.toFixed(2)}</strong></p>,
    },
    {
      minWidth: 150,
      field: "commissionAmount",
      headerName: "Commission",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: ({ row }) => <p className="c_success"><strong>${row.commissionAmount.toFixed(2)}</strong></p>,
    },
    {
      minWidth: 260,
      field: "paymentMethod",
      headerName: "Payment Method",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <p>
          <strong>{row.paymentMethod}</strong>
          <br />
          <span>{row.cardNumber}</span>
        </p>
      ),
    },
    {
      minWidth: 200,
      field: "transactionId",
      headerName: "Transaction Id",
      editable: false,
      sortable: false,
    },
    {
      minWidth: 160,
      field: "createdAt",
      headerName: "Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => moment(row.createdAt).format("DD MMM YYYY, HH:mm"),
    },
  ];
  let hidden: string[] = [];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          getRowId={(row: PaymentBookingItem) => row._id}
        />
      </div>
    </>
  );
};

export default PaymentsList;
